import { HttpClient } from '@euler/lib/request';
import { AiAttachmentInfo } from '@euler/model/apdm';

export class AiAttachmentService {
  constructor(private readonly api: HttpClient) {}

  async upload(form: FormData): Promise<AiAttachmentInfo> {
    return await this.api
      .post()
      .url('/ai/attachments')
      .data(form, false)
      .future();
  }

  async getMetadata(attachmentId: string): Promise<AiAttachmentInfo> {
    return await this.api
      .get()
      .url('/ai/attachments/:id', { id: attachmentId })
      .future();
  }

  /** The file's bytes, as a Blob: React Native reads no ArrayBuffer. */
  async download(attachmentId: string): Promise<Blob> {
    return await this.api
      .get()
      .url('/ai/attachments/:id/content', { id: attachmentId })
      .raw()
      .responseType('blob')
      .future();
  }
}
